/**
 * Provider identity for the SPA. Zero internal dependencies — every other
 * provider-kit module (`providerRegistry.ts`, `sourceConnection.ts`,
 * `sourceErrors.ts`, client factories, Settings) imports from here so a new
 * provider id is declared exactly once. See `docs/ADDING_A_PROVIDER.md`.
 */

export const CONNECTABLE_SOURCES = ['jira', 'github', 'slack', 'gmail'] as const;
export type ConnectableSource = (typeof CONNECTABLE_SOURCES)[number];

export function isConnectableSource(value: string): value is ConnectableSource {
  return (CONNECTABLE_SOURCES as readonly string[]).includes(value);
}
